































































































































































import ClearanceResponseCardHistory from "@/components/clearance/ClearanceResponseCardHistory.vue";
import ConfirmActionDialog from "@/components/utility/ConfirmActionDialog.vue";
import { AssetEnum } from "@/lib/AssetRepository";
import { CurrencyEnum } from "@/lib/enum/currency.enum";
import { RequestStatusEnum } from "@/lib/enum/request-status-enum";
import { IReportInstructionData } from "@/lib/interfaces/Report/IReportInstructionData";
import { formatCurrency } from "@/lib/utility/currency-helper";
import { formatYearsMonthDay, simpleDoubleDigitDate } from "@/lib/utility/date-helper";
import { getAutocompleteFilter } from "@/lib/utility/filter";
import { handleError } from "@/lib/utility/handleError";
import { $t } from "@/lib/utility/t";
import PermissionMixin from "@/mixins/PermissionMixin.vue";
import RulesMixin from "@/mixins/RulesMixin.vue";
import { Clearance, IClearance } from "@/models/clearance.entity";
import { ReportImageType } from "@/models/Report/ReportImageType";
import { ReportModule } from "@/store/modules/report.store";
import ReportImageUpload from "@/views/report/ReportImageUpload.vue";
import { mixins } from "vue-class-component";
import { Component, Prop } from "vue-property-decorator";
import MExpansion from "../utility/mmmint/MExpansion.vue";
import MIconButton from "../utility/mmmint/MIconButton.vue";
import MNoContent from "../utility/mmmint/MNoContent.vue";
import MTextField from "../utility/mmmint/MTextField.vue";

@Component({
  components: {
    MExpansion,
    MNoContent,
    MTextField,
    MIconButton,
    ClearanceResponseCardHistory,
    ConfirmActionDialog,
    ReportImageUpload
  },
  filters: { simpleDoubleDigitDate }
})
export default class ClearanceResponseCard extends mixins(PermissionMixin, RulesMixin) {
  readonly simpleDoubleDigitDate = simpleDoubleDigitDate;

  readonly getAutocompleteFilter = getAutocompleteFilter;

  readonly formatCurrency = formatCurrency;

  readonly CurrencyEnum = CurrencyEnum;

  readonly RequestStatusEnum = RequestStatusEnum;

  readonly statusIconMap = Clearance.statusIconMap;

  readonly statusColorMap = Clearance.statusColorMap;

  instruction: IReportInstructionData = {
    title: $t("report.completion.instruction.title"),
    text: $t("report.completion.instruction.description"),
    pictures: [AssetEnum.overview],
    example: AssetEnum.overview,
    display: true
  };
  asset = AssetEnum.carFrontRightOutline;
  example = AssetEnum.carFrontLeft;
  get type() {
    return ReportImageType.completion;
  }

  @Prop()
  value!: IClearance;

  @Prop()
  token!: string;

  isValid = false;
  loading = false;
  showConfirmDialog = false;
  showImageDialog = false;

  showRepairInformation = true;
  showCompletionImages = true;

  dto = {
    status: RequestStatusEnum.REPLIED,
    repairStart: this.value?.repairStart,
    repairEnd: this.value?.repairEnd,

    get repairStartFormable(): string {
      if (!this.repairStart) {
        return "";
      }
      return formatYearsMonthDay(new Date(this.repairStart));
    },

    set repairStartFormable(date: string) {
      if (date) {
        this.repairStart = new Date(date).toISOString();
      } else {
        this.repairStart = null;
      }
    },

    get repairEndFormable(): string {
      if (!this.repairEnd) {
        return "";
      }
      return formatYearsMonthDay(new Date(this.repairEnd));
    },

    set repairEndFormable(date: string) {
      if (date) {
        this.repairEnd = new Date(date).toISOString();
      } else {
        this.repairEnd = null;
      }
    }
  };

  get repairStartDisplay(): string {
    return this.value?.repairStart ? simpleDoubleDigitDate(this.value.repairStart) : "";
  }

  get repairEndDisplay(): string {
    return this.value?.repairEnd ? simpleDoubleDigitDate(this.value.repairEnd) : "";
  }

  get endDateRules() {
    return [
      (value: string) => {
        if (!value || !this.dto?.repairStart) return true;

        const startDate = new Date(this.dto.repairStart);
        const endDate = new Date(value);

        return endDate >= startDate || this.$t("objects.clearance.repairEndValidation").toString();
      }
    ];
  }

  get imageIds() {
    const images = ReportModule.overviews.filter(image => image.type === this.type);
    return images.map(image => image.uploadId);
  }

  get images() {
    return ReportModule.overviews;
  }

  /**
   * Checks if some image is still uploading
   */
  get isImageLoading() {
    return ReportModule.overviews.some(o => o.isLoading);
  }

  get isImageAddingValid() {
    return this.imageIds?.length;
  }

  get mapToImage() {
    if (!this.value.images) return [];
    return this.value.images.map(i => ({
      src: i.url,
      thumbnail: i.url,
      w: 0,
      h: 0,
      title: this.$t(`timeLine.PartnerReportDetailImageTimeLineElement.imageTypes.${i.type}`)
    }));
  }

  get partner() {
    return ReportModule.partner;
  }

  async confirmClearanceResponse() {
    this.loading = true;
    try {
      await this.value.respondAccept(this.token, {
        status: RequestStatusEnum.REPLIED,
        repairStart: this.dto.repairStart,
        repairEnd: this.dto.repairEnd,
        imageIds: this.imageIds
      });
      this.$toast.success(`${this.$t("clearance.response.success")} 👍`);
      this.showConfirmDialog = false;
      this.showImageDialog = false;
      ReportModule.removeAllOverviews();
    } catch (error) {
      handleError(error);
    } finally {
      this.loading = false;
    }
  }
}
